import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Stack,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import { Link } from 'react-router-dom'
import validator from 'validator'
import { registerUser, userExists } from '../../api/auth'
import SocialLoginButton from '../../components/buttons/SocialLoginButton'
import { CheckShield, EyeOff, EyeOpen, Search } from '../../components/icons/icons'
import PolicyModal from '../../components/modals/PolicyModal'
import useMobile from '../../hooks/useMobile'

import { AuthContext } from '../../App'
import { countries } from '../../components/countries/countries'
import InvalidInput from '../../components/input/InvalidInput'
import LocationPicker from '../../components/input/LocationPicker'

const privacyPolicy = [
  {
    title: 'Data Collection',
    description: 'We collect data for analytics and usage stats. Read Privacy Policy.',
  },
  {
    title: 'Promotions',
    description: 'Stay in the Loop with LVBL: Enjoy Exclusive Promotions Without Spam or Sharing Your Data!',
  },
]

const lvblWaiver = [
  {
    title: 'Data Collection',
    description: 'We collect data for analytics and usage stats. Read Privacy Policy.',
  },
  {
    title: 'Promotions',
    description: 'Stay in the Loop with LVBL: Enjoy Exclusive Promotions Without Spam or Sharing Your Data!',
  },
]

export const formatUniversalPhoneNumber = (phoneNumber: string) => {
  return phoneNumber.replace(/[^0-9]/g, '')
}

export const formatAmericanPhoneNumber = (phoneNumber: string, prefix: string) => {
  if (prefix != '+1') return phoneNumber

  let finalNumber = '('
  if (phoneNumber.length > 0) finalNumber += phoneNumber.substring(0, 1)
  else return ''
  if (phoneNumber.length > 1) finalNumber += phoneNumber.substring(1, 2)
  else return finalNumber
  if (phoneNumber.length > 2) finalNumber += phoneNumber.substring(2, 3)
  else return finalNumber

  if (phoneNumber.length > 3) finalNumber += phoneNumber.substring(3, 4)
  else return finalNumber.substring(0, 4)
  if (phoneNumber.length > 4) finalNumber += phoneNumber.substring(4, 5)
  else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 5)
  if (phoneNumber.length > 5) finalNumber += phoneNumber.substring(5, 6)
  else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 6)

  if (phoneNumber.length > 6) finalNumber += phoneNumber.substring(6, 7)
  else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7)
  if (phoneNumber.length > 7) finalNumber += phoneNumber.substring(7, 8)
  else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 8)
  if (phoneNumber.length > 8) finalNumber += phoneNumber.substring(8, 9)
  else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 9)
  if (phoneNumber.length > 9) finalNumber += phoneNumber.substring(9, 10)
  else return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 10)

  return finalNumber.substring(0, 4) + ') ' + finalNumber.substring(4, 7) + '-' + finalNumber.substring(7, 11)
}

const RegisterPage = () => {
  const isMobile = useMobile(595)

  const [showPw, setShowPw] = useState(false)
  const [requiredData, setRequiredData] = useState(false)
  const [waiver, setWaiver] = useState(false)

  const { loginLoading, signInWithGoogle, signInWithFacebook, signInWithApple, signInWithEmailAndPassword } =
    useContext(AuthContext)

  const [data, setData] = useState({
    full_name: '',
    email: '',
    password: '',
    phone_number: '',
    phone_number_prefix: '+1',

    promotion_opt_in: false,

    emergency_contact_phone_number: '',
    emergency_contact_phone_number_prefix: '+1',

    emergency_contact_name: '',
    address: '',
    address_location: null,
  })

  const [errors, setErrors] = useState({
    full_name: false,
    email: false,
    password: false,
    phone_number: false,
    // emergency_contact_phone_number: false,
    // emergency_contact_name: false,
    address: false,
    privacy: false,
    waiver: false,
  })

  const targets: any = {
    full_name: useRef<HTMLInputElement>(null),
    email: useRef<HTMLInputElement>(null),
    password: useRef<HTMLInputElement>(null),
    phone_number: useRef<HTMLInputElement>(null),
    emergency_contact_phone_number: useRef<HTMLInputElement>(null),
    emergency_contact_name: useRef<HTMLInputElement>(null),
    address: useRef<HTMLInputElement>(null),
  }

  const validateData = () => {
    console.log(data.phone_number_prefix + data.phone_number)
    console.log(data.emergency_contact_phone_number_prefix + data.emergency_contact_phone_number)

    let errors = {
      full_name: data.full_name.length == 0,
      email: !validator.isEmail(data.email) || !userExistsQuery.isSuccess,
      password: !validator.isStrongPassword(data.password),
      phone_number: !validator.isMobilePhone(
        data.phone_number_prefix +
        formatUniversalPhoneNumber(formatAmericanPhoneNumber(data.phone_number, data.phone_number_prefix))
      ),
      // emergency_contact_phone_number: !validator.isMobilePhone(
      //   data.emergency_contact_phone_number_prefix +
      //     formatUniversalPhoneNumber(
      //       formatAmericanPhoneNumber(data.emergency_contact_phone_number, data.emergency_contact_phone_number_prefix)
      //     )
      // ),
      // emergency_contact_name: data.emergency_contact_name.length == 0,
      address: data.address.length < 10,
      privacy: !requiredData,
      waiver: !waiver,
    }

    setErrors(errors)

    if (Object.values(errors).some((value: any) => value == true)) {
      const targetName = Object.entries(errors).find(([_, value]: any) => value == true)?.[0]

      if (targetName) targets[targetName]?.current?.scrollIntoView({ behavior: 'smooth' })
    }

    return !Object.values(errors).some((value: any) => value == true)
  }

  // const validInputs = (
  //     fullNameValid &&
  //     emailValid &&
  //     passwordValid &&
  //     phoneNumberValid &&
  //     emergencyContactPhoneNumberValid &&
  //     addressValid &&
  //     emergencyContactNameValid &&
  //     requiredData &&
  //     waiver
  // )

  // const validatePhoneNumber = (phoneNumber : string) => {
  //     const regex = /^\(\d{0,3}\)? ?\d{0,3}?-?\d{0,4}?$/;
  //     return regex.test(phoneNumber);
  // };

  const formatPhoneNumber = (value: string) => {
    console.log('NEW VALUE: ', value, value.length)

    if (value == '') return value
    if (value == '(') return ''

    if (value.charAt(0) != '(') return '(' + value

    if (value.length == 4) return value + ') '
    if (value.length == 5) return value.substring(0, 3)
    if (value.length == 10 && !value.includes('-')) return value.substring(0, 9) + '-' + value.substring(9)
    if (value.length == 10) {
      return value.substring(0, 9)
    }

    return value.substring(0, 14)

    // if (!value) return value;
    // const phoneNumber = value.replace(/[^\d]/g, '');
    // const phoneNumberLength = phoneNumber.length;
    // if (phoneNumberLength < 4) return phoneNumber;
    // if (phoneNumberLength < 7) {
    //   return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    // }
    // return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  }

  const handleChangeData = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value

    if (e.target.name == 'phone_number' || e.target.name == 'emergency_contact_phone_number') {
      value = formatPhoneNumber(value)
    }

    setData((prev) => ({ ...prev, [e.target.name]: value }))
  }

  function isNumeric(str: string) {
    // Using regular expression to check if the string consists of only digits
    return /^\d+$/.test(str)
  }

  const {
    isOpen: isPrivacyModalOpen,

    onClose: closePrivacyModal,
  } = useDisclosure()

  const {
    isOpen: isWaiverModalOpen,

    onClose: closeWaiverModal,
  } = useDisclosure()

  const userExistsQuery = useQuery(['userExists', data.email], () => userExists(data.email), {})

  useEffect(() => {
    console.log(data.email)
  }, [data.email])

  const userRegistrationMutation = useMutation(registerUser, {
    onSuccess: () => {
      signInWithEmailAndPassword(data.email, data.password)
    },
    onError: (err) => {
      console.log(err)
    },
  })

  const selectRef = useRef<HTMLSelectElement>(null)

  const [selectWidth, setSelectWidth] = useState(0)

  useEffect(() => {
    const handleResize = () => {
      if (selectRef.current) {
        setSelectWidth(selectRef.current.clientWidth)
      }
    }

    // Initial width calculation
    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [selectRef])

  return (
    <>
      <PolicyModal
        isOpen={isPrivacyModalOpen}
        onClose={closePrivacyModal}
        header="Privacy Policy"
        content={privacyPolicy}
      />

      <PolicyModal isOpen={isWaiverModalOpen} onClose={closeWaiverModal} header="LVBL Waiver" content={lvblWaiver} />

      <Box w="100%" maxW="600px">
        {/* <Box 
            bgImage='/logo_black.svg' 
            w='118px' h='38px' 
            m={isMobile ? '0px auto 30px auto' : '0px 0px 30px 0px'} 
        /> */}
        <Text variant="title" mb="20px" fontSize={isMobile ? '2xl' : '5xl'}>
          Sign up
        </Text>
        <Text variant="subtle" size="md" mb="20px">
          Continue signing up with
        </Text>
        <SimpleGrid minChildWidth="60px" gap="5px">
          <SocialLoginButton
            icon="/socials/google.svg"
            label="Google"
            isMobile={isMobile}
            onClick={() => {
              localStorage.setItem('signUpWithSocial', '1')
              signInWithGoogle()
            }}
          />
          <SocialLoginButton
            icon="/socials/facebook.svg"
            label="Facebook"
            isMobile={isMobile}
            onClick={() => {
              localStorage.setItem('signUpWithSocial', '1')
              signInWithFacebook()
            }}
          />
          <SocialLoginButton
            icon="/socials/apple.svg"
            label="Apple"
            isMobile={isMobile}
            onClick={() => {
              localStorage.setItem('signUpWithSocial', '1')
              signInWithApple()
            }}
          />
        </SimpleGrid>
        <Flex alignItems="center" gap="10px" mt="10px" mb="20px">
          <Divider />
          <Text variant="subtle" w="740px" textAlign="center" fontSize="md">
            or create an account
          </Text>
          <Divider />
        </Flex>

        <FormControl mb="20px" isInvalid={errors.full_name} ref={targets.full_name}>
          <FormLabel>Full Name</FormLabel>
          <Input name="full_name" onChange={handleChangeData} value={data.full_name} size="lg" type="text" />
          <FormErrorMessage>Full name must not be empty</FormErrorMessage>
        </FormControl>

        <FormControl mb="20px" isInvalid={errors.email} ref={targets.email}>
          <FormLabel>Email Address</FormLabel>
          <Input
            name="email"
            onChange={handleChangeData}
            value={data.email}
            size="lg"
            placeholder="example@example.com"
            type="email"
          />
          <FormErrorMessage>
            {userExistsQuery.isSuccess && !userExistsQuery.isFetching ? 'Invalid email' : 'Email already exists'}
          </FormErrorMessage>
        </FormControl>

        <FormControl mb="20px" isInvalid={errors.address} ref={targets.address}>
          <FormLabel>Full Home Address</FormLabel>
          <Box border="1px solid #DCE2EA" borderRadius="4px" pl="4px">
            <LocationPicker
              location={data.address}
              setLocation={(v: string) => setData((prev) => ({ ...prev, address: v }))}
              placeholder=""
              setCoordinates={(v: any) => setData((prev) => ({ ...prev, address_location: v }))}
              fontSize="16"
            />
          </Box>
          {/* <Input 
                name='address'
                onChange={handleChangeData}
                value={data.address}
                size='lg'
                type='text'
            /> */}
          {errors.address ? (
            <FormErrorMessage>Invalid address</FormErrorMessage>
          ) : (
            <FormHelperText color="#7E8B9A">
              <Flex gap="4px">
                <Icon w="14px" h="14px" viewBox="0 0 14 13" fill="none">
                  <CheckShield />
                </Icon>
                <Text>This information is for shipping and emergency purposes only and will remain private.</Text>
              </Flex>
            </FormHelperText>
          )}
        </FormControl>

        <FormControl
          mb="30px"
          isInvalid={errors.password || (!validator.isStrongPassword(data.password) && data.password.length > 0)}
          ref={targets.password}
        >
          <FormLabel>Password</FormLabel>
          <InputGroup size="lg">
            <Input
              name="password"
              onChange={handleChangeData}
              value={data.password}
              size="lg"
              type={showPw ? 'text' : 'password'}
            />
            <InputRightElement width="4.5rem">
              <IconButton
                ml="6"
                aria-label="show / hide password"
                variant="unstyled"
                onClick={() => setShowPw(!showPw)}
                icon={
                  <Icon w="22px" h="22px" color="black">
                    {showPw ? <EyeOff /> : <EyeOpen />}
                  </Icon>
                }
              />
            </InputRightElement>
          </InputGroup>
          <FormErrorMessage>
            Password must include at least 8 characters, 1 uppercase letter, 1 lowercase letter, 1 number and 1 special
            character
          </FormErrorMessage>
        </FormControl>

        <FormControl mb="20px" isInvalid={errors.phone_number} ref={targets.phone_number}>
          <FormLabel>Phone (Select Your Country's Calling Code First)</FormLabel>
          <Flex gap="5px" position="relative">
            <Select
              w="140px"
              size="lg"
              name="phone_number_prefix"
              borderRadius="0"
              ref={selectRef}
              borderColor="#DCE2EA"
              borderWidth="1.5px"
              color="white"
              _hover={{}}
              icon={
                <Icon w="18px" cursor="pointer" h="18px" color="black" viewBox="0 0 18 18">
                  <Search />
                </Icon>
              }
              value={data.phone_number_prefix}
              onChange={(e: any) => setData((prev) => ({ ...prev, phone_number_prefix: e.target.value }))}
            >
              {countries.map((country: any, index: number) => {
                return (
                  <option key={index} value={country.dial_code}>
                    {country.dial_code} ({country.name})
                  </option>
                )
              })}
            </Select>
            <Flex
              position="absolute"
              gap="12px"
              bgColor="white"
              top="4px"
              left="4px"
              w={'calc(' + selectWidth + 'px - 34px)'}
            //w="75px"
            >
              <Input
                border="0"
                name="phone_number_prefix"
                value={data.phone_number_prefix}
                onChange={(e) => {
                  if (
                    e.target.value.charAt(0) == '+' &&
                    (e.target.value.length == 1 || isNumeric(e.target.value.substring(1)))
                  )
                    handleChangeData(e)
                }}
              />
            </Flex>

            <Input
              name="phone_number"
              onChange={(e: any) => {
                setData({ ...data, phone_number: formatUniversalPhoneNumber(e.target.value) })

                // if (validatePhoneNumber(formatPhoneNumber(e.target.value)) || e.target.value.length == 0 || e.target.value == "(") {
                //     handleChangeData(e)
                // }
              }}
              value={formatAmericanPhoneNumber(data.phone_number, data.phone_number_prefix)}
              size="lg"
              placeholder="(954) 444-4444"
              type="tel"
            />
          </Flex>

          <FormErrorMessage>Invalid phone number</FormErrorMessage>
        </FormControl>

        <FormControl
          mb="10px"
          // isInvalid={errors.emergency_contact_phone_number}
          ref={targets.emergency_contact_phone_number}
        >
          <FormLabel>Emergency Contact</FormLabel>
          <Flex gap="5px" position="relative">
            <Select
              w="140px"
              size="lg"
              name="emergency_contact_phone_number_prefix"
              borderRadius="0"
              borderColor="#DCE2EA"
              borderWidth="1.5px"
              _hover={{}}
              icon={
                <Icon w="18px" h="18px" color="black" cursor="pointer" viewBox="0 0 18 18">
                  <Search />
                </Icon>
              }
              value={data.emergency_contact_phone_number_prefix}
              onChange={(e: any) =>
                setData((prev) => ({ ...prev, emergency_contact_phone_number_prefix: e.target.value }))
              }
            >
              {countries.map((country: any, index: number) => {
                return (
                  <option key={index} value={country.dial_code}>
                    {country.dial_code} ({country.name})
                  </option>
                )
              })}
            </Select>
            <Flex
              position="absolute"
              gap="12px"
              bgColor="white"
              top="4px"
              left="4px"
              w={'calc(' + selectWidth + 'px - 34px)'}
            >
              <Input
                border="0"
                pt="8px"
                pl="16px"
                pb="8px"
                name="emergency_contact_phone_number_prefix"
                value={data.emergency_contact_phone_number_prefix}
                onChange={(e) => {
                  if (
                    e.target.value.charAt(0) == '+' &&
                    (e.target.value.length == 1 || isNumeric(e.target.value.substring(1)))
                  )
                    handleChangeData(e)
                }}
              />
            </Flex>
            <Input
              name="emergency_contact_phone_number"
              onChange={(e) => {
                setData({ ...data, emergency_contact_phone_number: formatUniversalPhoneNumber(e.target.value) })

                // if (validatePhoneNumber(formatPhoneNumber(e.target.value)) || e.target.value.length == 0 || e.target.value == "(") {
                //     handleChangeData(e)
                // }
              }}
              value={formatAmericanPhoneNumber(
                data.emergency_contact_phone_number,
                data.emergency_contact_phone_number_prefix
              )}
              size="lg"
              placeholder="(954) 444-4444"
              type="tel"
            />
          </Flex>
          <FormErrorMessage>Invalid phone number</FormErrorMessage>
        </FormControl>

        <FormControl
          mb="20px"
          // isInvalid={errors.emergency_contact_name}
          ref={targets.emergency_contact_name}
        >
          <Input
            name="emergency_contact_name"
            onChange={handleChangeData}
            value={data.emergency_contact_name}
            size="lg"
            placeholder="Emergency Contact Name"
            type="text"
          />
          {/* {errors.emergency_contact_name ? ( 
            <FormErrorMessage>Name must not be empty</FormErrorMessage>
          ) */}
          <FormHelperText color="#7E8B9A">
            <Flex gap="4px">
              <Icon w="14px" h="14px" viewBox="0 0 14 13" fill="none">
                <CheckShield />
              </Icon>
              <Text>This information is for shipping and emergency purposes only and will remain private.</Text>
            </Flex>
          </FormHelperText>
        </FormControl>

        <Stack justifyContent="left" mb="20px" gap="5px">
          <Checkbox
            name="promotion_opt_in"
            onChange={(e) => setData((prev) => ({ ...prev, [e.target.name]: e.target.checked }))}
            isChecked={data.promotion_opt_in}
          >
            <Text fontWeight="600">Promotions via push or email</Text>
          </Checkbox>
          <Text variant="subtle" fontSize="md" ml="26px" mb="10px">
            Stay in the Loop with LVBL: Enjoy Exclusive Promotions Without Spam or Sharing Your Data!
          </Text>
          <Checkbox isChecked={requiredData} onChange={(e) => setRequiredData(e.target.checked)}>
            <Text fontWeight="600">Required data for LVBL use</Text>
          </Checkbox>
          <Text variant="subtle" fontSize="md" ml="26px" mb="10px">
            <span>
              LVBL gathers essential data for app operation, including analytics and usage stats. Read{' '}
              <u
                style={{ color: '#171C22', cursor: 'pointer' }}
                onClick={() => window.open('https://lvbl.webflow.io/privacy-policy')}
              >
                Privacy Policy
              </u>
              {''} and{' '}
              <u
                style={{ color: '#171C22', cursor: 'pointer' }}
                onClick={() => window.open('https://lvbl.club/terms-of-service')}
              >
                Terms of Service
              </u>
              {''} and agree to the EULA terms mentioned in the links to continue.
            </span>
          </Text>

          <InvalidInput isError={errors.privacy} override="Please agree to the privacy policy & terms of service" />
          {errors.privacy && <Spacer h="20px" />}
          <Checkbox isChecked={waiver} onChange={(e) => setWaiver(e.target.checked)}>
            <Text variant="subtle" fontSize="md">
              I have read and agree to the terms of the{' '}
              <u
                style={{ color: '#171C22', cursor: 'pointer' }}
                onClick={(e: any) => {
                  e.stopPropagation()
                  e.preventDefault()
                  window.open('https://shop.lvbl.club/pages/terms-conditions-refund-policy')
                  //openWaiverModal()
                }}
              >
                LVBL Waiver.
              </u>
            </Text>
          </Checkbox>

          <InvalidInput isError={errors.waiver} override="Please agree to the LVBL waiver" />
        </Stack>

        <Button
          variant="heavy"
          size="lg"
          w="100%"
          mb="10px"
          isLoading={userRegistrationMutation.isLoading || loginLoading}
          onClick={() =>
            validateData()
              ? userRegistrationMutation.mutate({
                ...data,
                phone_number:
                  data.phone_number_prefix +
                  formatUniversalPhoneNumber(formatAmericanPhoneNumber(data.phone_number, data.phone_number_prefix)),
                emergency_contact_phone_number:
                  data.emergency_contact_phone_number_prefix +
                  formatUniversalPhoneNumber(
                    formatAmericanPhoneNumber(
                      data.emergency_contact_phone_number,
                      data.emergency_contact_phone_number_prefix
                    )
                  ),
              })
              : {}
          }
        >
          Sign up for Free
        </Button>
        <Flex justifyContent="center" gap="10px">
          <Text variant="subtle">Have an account?</Text>
          <Link to="/auth/login">
            <Button variant="link" textStyle="underline" size="md">
              Login
            </Button>
          </Link>
        </Flex>
      </Box>
    </>
  )
}

export default RegisterPage
